<template>
  <b-card>
    <interview-subject />
    <title-name />
    <status-select />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Interview_statuses/elements/Title.vue'
import StatusSelect from '@/views/Admin/Defines/Interview_statuses/elements/Status.vue'
import InterviewSubject from '@/views/Admin/Defines/Interview_statuses/elements/InterviewSubject.vue'

export default {
  name: 'InterviewStatusForm',
  components: {
    BCard,
    TitleName,
    StatusSelect,
    InterviewSubject,
  },
}
</script>
